<template>
  <div class="publicMain">
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="采集时间">
          <el-col :span="11">
            <el-date-picker
                style="width: 100%"
                v-model="form.start"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-date-picker
                style="width: 100%"
                v-model="form.end"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="add">新增</el-button>
      <!-- <el-button type="primary" @click="addClassify" size="mini">新增分类</el-button> -->
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" style="color:#dd3020;" effect="light" content="删除" placement="top-start">
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible"  width="40%">
      <div style="width:100%; width: 90%;margin: 0px auto;">
        <el-form
          v-if="visible"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="血糖" prop="bloodSugar">
            <el-input v-model="ruleForm.bloodSugar">
              <template slot="append">mmol/L</template>
            </el-input>
          </el-form-item>
          <el-form-item label="收缩压" prop="shrink">
            <el-input v-model="ruleForm.shrink">
              <template slot="append">mmHg</template>
            </el-input>
          </el-form-item>
          <el-form-item label="扩张压" prop="expand">
            <el-input v-model="ruleForm.expand">
              <template slot="append">mmHg</template>
            </el-input>
          </el-form-item>
          <el-form-item label="血氧饱和度" prop="blood">
            <el-input v-model="ruleForm.blood"></el-input>
          </el-form-item>
          <el-form-item label="心率" prop="heartRate">
            <el-input v-model="ruleForm.heartRate">
              <template slot="append">次/分钟</template>
            </el-input>
          </el-form-item>
          <div class="button">
            <div class="button-mid" v-if="title!='查看'">
              <el-button type="primary" @click="save" >确定</el-button>
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
            <div class="button-btn" v-else >
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {

  oldManHealthList,
  oldManHealthDelete,
  oldManHealthEdit,
  oldManHealthCheck
} from "../api";
//救助管理
import request from "@/utils/request.js";
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {
    upload
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {

      },
      rules: {

          name: [
            { required: true, message: '请输入姓名', trigger: 'change' }
          ],
          bloodSugar: [
            { required: true, message: '请输入血糖', trigger: 'change' }
          ],
          shrink: [
            { required: true, message: '请输入收缩压', trigger: 'change' }
          ],
          expand: [
            { required: true, message: '请输入扩张压', trigger: 'change' }
          ],
          blood: [
            { required: true, message: '请输入血氧饱和度', trigger: 'change' }
          ],
          heartRate: [
            { required: true, message: '请输入心率', trigger: 'change' }
          ],

        },
      fileList: [],
      typeImg: "",
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "bloodSugar",
          label: "血糖（mmol/L)"
        },
        {
          prop: "shrink",
          label: "收缩压(mmHg)"
        },
        {
          prop: "expand",
          label: "扩张压(mmHg)"
        },
        {
          prop: "blood",
          label: "血氧饱和度"
        },
        {
          prop: "heartRate",
          label: "心率(次/分钟)"
        },
        {
          prop: "releaseTime",
          label: "采集类型"
        },
        {
          prop: "createDate",
          label: "采集时间"
        },
        {
          label: "操作",
          type: "button"
        }
      ],
      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      ruleForm: {},
      show:true,
    };
  },
  methods: {
    //查询
    onCheck() {
      this.getOldManHealthListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form
      });
      this.$message({
        message: "查询成功",
        type: "success"
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.getOldManHealthListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      this.$message({
        message: "重置成功",
        type: "success"
      });
    },
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOldManHealthListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getOldManHealthListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到列表
    getOldManHealthListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldPeopleId:this.$route.query.id
      });
      oldManHealthList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.title = "新增";
      this.ruleForm = {}
      // this.$refs.ruleForm.clearValidate()
    },
    check(e){
      this.visible = true
      this.getData(e.id)
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.visible = true
      this.getData(e.id)
      this.title = "编辑";
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          oldManHealthDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getOldManHealthListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //保存
    save(){
      this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.ruleForm = Object.assign({},this.ruleForm,{
              oldPeopleId:this.$route.query.id
            })
            oldManHealthEdit(this.ruleForm).then(res=>{
              this.$message({
                 type: "success",
                 message: this.title=='新增'?"新增成功":"编辑成功"
               });
               this.visible = false
               this.getOldManHealthListAPI()
            })
          }
        });
    },
    //回写数据
    getData(e) {
      oldManHealthCheck({ id: e }).then((res) => {
        this.ruleForm = Object.assign({}, res.content, {
          // dietTaboo: this.funTurn(res.content.dietTaboo),
          // health: this.funTurn(res.content.health),
        });

      });
    },
  },
  created() {
    console.log(this.$route.query);
    this.getOldManHealthListAPI();

  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-radio {
  margin: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
.button-btn {
  justify-content: center;
  display: flex;
}
</style>
